// extracted by mini-css-extract-plugin
module.exports = {"menu":"header-nav-menu_menu__1QrXt","menu-list":"header-nav-menu_menu-list__7AsuO"};